import { render } from "./WhisperTest.vue?vue&type=template&id=06305274&scoped=true"
import script from "./WhisperTest.vue?vue&type=script&lang=js"
export * from "./WhisperTest.vue?vue&type=script&lang=js"

import "./WhisperTest.vue?vue&type=style&index=0&id=06305274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06305274"]])

export default __exports__